import { inject, type InjectionKey } from 'vue';

export function injectOrFail<T>(
  key: InjectionKey<T>,
  error = `No Provider for ${String(key)}`,
): T {
  const dep = inject(key);
  if (!dep) {
    throw new Error(error);
  }
  return dep;
}
